module.exports = "/_next/static/images/wallet-b7bda91fdc9b283692bb20631ec91de3.svg";